// extracted by mini-css-extract-plugin
export var blob = "NavigationButton-module--blob--d52f5";
export var button = "NavigationButton-module--button--df949";
export var line = "NavigationButton-module--line--15457";
export var lines = "NavigationButton-module--lines--82066";